<template>
  <collapsible-widget
    title="ZASILENIE MANUALNE"
    :accordion="accordion"
    :default-expanded="true"
  >
    <div class="mr-3 ml-3">
      <b-form>
        <div class="mt-2 mb-2 d-flex justify-content-center align-items-center">
          <strong>Wybierz sposób Edycji</strong>
        </div>
        <b-alert :show="true" variant="info">
          <strong>Informacja.</strong>
          <span
            >Załadowane dane przestrzenne powinny być zapisane w układzie
            współrzędnym WGS84</span
          >
        </b-alert>
        <b-form-group
          ><small class="text-danger" v-show="formErrors.fileError"
            >Należy wybrać plik w formacie csv.</small
          ><b-form-row class="mb-1">
            <b-col md="12">
              <b-form-file
                class="file-input"
                accept=".csv"
                placeholder=""
                id="fileInput"
                ref="fileinput"
                v-model="file"
                :state="formErrors.fileError ? false : null"
              ></b-form-file>
            </b-col>
          </b-form-row>
          <b-button
            class="col-md-12"
            variant="primary"
            @click="newManualImportDataInit('uploadFormFile')"
          >
            <span>Załaduj plik</span>
          </b-button>
          <!-- <div
            class="mt-2 mb-2 d-flex justify-content-center align-items-center"
          >
            lub
          </div> -->
          <!-- <div>
            <b-alert
              :show="!$context.hasPermission('Registry_of_export_data')"
              variant="info"
            >
              <strong>Informacja.</strong>
              <span
                >Nie masz uprawnień do przetwarzania danych z
                inwentaryzacji.</span
              ></b-alert
            >
            <b-alert :show="isInventarizationExportInAction" variant="info">
              <strong>Informacja.</strong>
              <span v-if="this.inventarizationExportStatus.makingExport"
                >Zainicjowano przygotowywanie danych z poprzedniej
                inwentaryzacji.</span
              >
              <span v-if="this.inventarizationExportStatus.checkingExportStatus"
                >Dane z inwentaryzacji {{ this.selectedInventarizationId }} są w
                przygotowywaniu.</span
              >
              <span v-if="this.inventarizationExportStatus.downloadingFile"
                >Rozpoczęto pobieranie danych z poprzedniej
                inwentaryzacji.</span
              >
              <span>Proszę czekać.</span>
            </b-alert>
            <label for="inventarization-select" class="col-form-label"
              >Wybierz inwentaryzację</label
            >
            <b-form-select
              :disabled="
                isInventarizationExportInAction ||
                  !$context.hasPermission('Registry_of_export_data')
              "
              id="inventarization-select"
              v-model="selectedInventarizationId"
              :options="inventarizations"
              class="mb-3"
            >
              <template slot="first">
                <option :value="null">Wybierz</option>
              </template>
            </b-form-select>
            <b-button
              :disabled="
                isInventarizationExportInAction ||
                  !$context.hasPermission('Registry_of_export_data')
              "
              class="col-md-12"
              variant="primary"
              @click="newManualImportDataInit('uploadDataFromInventarization')"
              ><span v-if="!isInventarizationExportInAction"
                >Załaduj dane z inwentaryzacji</span
              >
              <span v-if="isInventarizationExportInAction"
                ><icon name="circle-notch" spin
              /></span>
            </b-button>
            <b-button
              v-if="inventarizationExportData"
              class="col-md-12 mt-2"
              variant="primary"
              @click="downloadCsvFile(inventarizationExportData)"
            >
              <span>Pobierz dane z inwentaryzacji</span>
            </b-button>
          </div> -->
        </b-form-group> </b-form
      ><b-form>
        <b-row class="mr-0 ml-0 pl-0 pr-0">
          <label for="description" class="col-form-label">Opis zasilenia</label>
          <b-form-textarea
            type="text"
            rows="3"
            placeholder="Wprowadź opis zasilenia"
            id="description"
            v-model="description"
          ></b-form-textarea> </b-row
        ><b-row class="mb-4">
          <b-col md="12" class="d-flex align-items-center">
            <label for="clearLayerCheckbox" class="col-form-label">
              Wyczyść warstwę przed wgraniem danych
            </label>
            <b-badge
              class="ml-1"
              pill
              variant="secondary"
              v-b-tooltip.hover
              title="Oznaczenie opcji wyczyść warstwę spowoduje usunięcie wszystkich dotychczas wprowadzonych rekordów dla tej warstwy."
            >
              <b>i</b>
            </b-badge>
            <div class="ml-2 pr-0">
              <b-form-checkbox
                id="clearLayerCheckbox"
                v-model="clearLayer"
                @click.native="clickClearLayerCheckbox"
              ></b-form-checkbox>
            </div>
          </b-col>
        </b-row>
        <b-button
          class="w100 mb-1"
          variant="primary"
          @click="submitManualImport()"
        >
          <span>Publikuj</span>
        </b-button>
        <b-button
          class="w100 mb-1"
          variant="primary"
          @click="saveEditedLayersToFile()"
        >
          <span>Zapisz do pliku</span>
        </b-button>
        <b-button class="w100" variant="outline-secondary" @click="cancel()">
          <span>Anuluj</span>
        </b-button>
      </b-form>
    </div>
    <b-modal
      size="md"
      centered
      :visible="bulkDataInfoModal"
      @hidden="hideBulkDataInfoModal"
      ><template slot="modal-title">Potwierdzenie</template>
      <p class="p-0">
        Załadowanie pliku do Rejestru zasileń nie powoduje wypełnienia obowiązku
        sprawozdawczego w ramach inwentaryzacji, o której mowa w art. 29 lub w
        art. 29c oraz art. 29d ust. 4 ustawy o wspieraniu rozwoju usług i sieci
        telekomunikacyjnych. Po wczytaniu wszystkich danych i Walidacji
        inwentaryzacji należy uruchomić Zamknięcie inwentaryzacji.
        <br /><br />Import został uruchomiony. Czy chcesz przejść do rejestru
        zasileń?
      </p>
      <div slot="modal-footer">
        <b-btn variant="outline-secondary" @click="hideBulkDataInfoModal()"
          >Nie</b-btn
        >
        <b-btn
          variant="primary"
          @click="
            hideBulkDataInfoModal();
            redirectToDataFeedRecord();
          "
          >Tak</b-btn
        >
      </div>
    </b-modal>
    <b-modal
      size="md"
      centered
      :visible="exitConfirmationModal"
      @hidden="hideExitModal"
      ><template slot="modal-title">Zamykanie trybu edycji</template>
      <p class="p-0">
        Wszystkie obiekty w warstwie edycji zostaną usunięte. Czy chcesz zapisać
        zmiany?
      </p>
      <div slot="modal-footer">
        <b-btn
          variant="primary"
          @click="
            saveEditedLayersToFile();
            exitEditMode();
          "
          >Zapisz</b-btn
        >
        <b-btn variant="outline-secondary" @click="exitEditMode()"
          >Nie zapisuj</b-btn
        >
        <b-btn variant="outline-secondary" @click="hideExitModal()"
          >Anuluj</b-btn
        >
      </div>
    </b-modal>
    <b-modal
      size="md"
      centered
      :visible="newFileModal"
      @hidden="hideNewFileModal"
      ><template slot="modal-title">Tworzenie nowego pliku</template>
      <p class="p-0">
        Czy chcesz wyczyścić wszystkie warstwy i zapisać zmiany?
      </p>
      <div slot="modal-footer">
        <b-btn
          variant="primary"
          @click="
            saveEditedLayersToFile();
            resetFeatures();
            newManualImportData();
            hideNewFileModal();
          "
          >Zapisz i resetuj</b-btn
        >
        <b-btn
          variant="outline-secondary"
          @click="
            newManualImportData();
            hideNewFileModal();
          "
          >Dodaj obiekty</b-btn
        >
        <b-btn variant="outline-secondary" @click="hideNewFileModal()"
          >Anuluj</b-btn
        >
      </div>
    </b-modal>
    <b-modal
      size="md"
      centered
      :visible="harmonogramModal"
      @hidden="hideHarmonogramModal"
      ><template slot="modal-title">Uwaga</template>
      <p class="p-0">
        Ze względu na harmonogram zasileń import nie może zostać zrealizowany.
        Wznowienie importu nastąpi:
        {{ nextAvailableImportDay }}.
      </p>
      <div slot="modal-footer">
        <b-btn variant="outline-secondary" @click="hideHarmonogramModal()"
          >Ok</b-btn
        >
      </div> </b-modal
    ><b-modal size="md" centered :visible="infoModal" @hidden="hideInfoModal"
      ><template slot="modal-title">Informacja</template>
      <p v-if="statementSubmited">
        Złożono oświadczenie o nieposiadaniu danych o infrastrukturze i usługach
        telekomunikacyjnych - funkcjonalność importu jest niedostępna.
      </p>
      <p v-else>
        Inwentaryzacja została zamknięta przez użytkownika - funkcjonalność
        importu zostanie udostępniona w następnym oknie inwentaryzacyjnym.
      </p>
      <div slot="modal-footer">
        <b-btn variant="outline-secondary" @click="hideInfoModal()">Ok</b-btn>
      </div>
    </b-modal>
    <b-modal v-model="clearLayerCheckboxModal" size="lg" centered>
      <template slot="modal-title">
        Wyczyść warstwę przed wgraniem danych
      </template>
      <p>
        <strong
          >Oznaczenie opcji wyczyść warstwę spowoduje usunięcie wszystkich
          dotychczas wprowadzonych rekordów dla tej warstwy.</strong
        >
      </p>
      <p>Czy chcesz kontynuować?</p>
      <div slot="modal-footer">
        <b-btn variant="outline-secondary mr-2" @click="cancelChange"
          >Nie</b-btn
        >
        <b-btn variant="primary mr-2" @click="confirmChange">Tak</b-btn>
      </div></b-modal
    >

    <b-modal
      size="md"
      centered
      :visible="Boolean(showPodstawyPrawneFor.length)"
      v-for="layer in showPodstawyPrawneFor"
      :key="layer.title"
    >
      <template slot="modal-title">
        Wybierz podstawę prawną dla
        {{ layer.title }}
      </template>
      <b-select v-model="selectedPodstawaPrawna" class="w-100 cursor-pointer">
        <option :title="'Wybierz'" :value="null" disabled>Wybierz</option>
        <option
          v-for="podstawa in layer.options"
          :title="podstawa"
          :key="podstawa"
          :value="podstawa"
          class="option-wrap"
        >
          {{ podstawa }}
        </option>
      </b-select>
      <div slot="modal-footer">
        <b-btn
          variant="outline-secondary mr-2"
          @click="showPodstawyPrawneFor = []"
          >Anuluj</b-btn
        >
        <b-btn
          variant="primary mr-2"
          @click="confirmPodstawyPrawne(layer.id)"
          :disabled="!selectedPodstawaPrawna"
        >
          <span v-if="showPodstawyPrawneFor.length > 1">Dalej</span>
          <span v-else>Wyślij</span>
        </b-btn>
      </div></b-modal
    >

    <map-columns-modal
      :visible="showMapColumnsModal"
      :expectedColumns="expectedColumns"
      :fields="responseBodyFields"
      @hide="showMapColumnsModal = false"
      @save="modifyResponseColumns"
    />
    <loading-overlay
      :active.sync="isLoading"
      :is-full-page="false"
    ></loading-overlay>
  </collapsible-widget>
</template>

<script>
import { Api as ApiHarmonogramZasilen } from '../api/api-harmonogram-zasilen.js';
import { Api as ApiZasilenia } from '../api/api-zasilenia-masowe-nowy-import.js';
import { Api as ApiSysPrzePli } from '../api/api-system-przechowywania-plikow';
import { Api as ApiKonwersja } from '../api/api-konwersja';
import { Api as ApiWarstwy } from '../api/api-warstwy.js';
import { transform } from 'ol/proj';
import moment from 'moment';
import { mapGetters } from 'vuex';
import {
  WINDOW_NOTIFICATION_SHOW,
  FEATURES_SET,
} from '../store/mutations.type';
import {
  EDIT_SESSION_ADD_FEATURE,
  EDIT_SESSION_END,
  EDIT_SESSION_VALIDATE_FEATURES,
  EDIT_SESSION_GET_FEATURE_GEOMETRY,
  EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY,
} from '../store/actions.type';
import CollapsibleWidget from './CollapsibleWidget';
import MapColumnsModal from './MapColumnsModal';
import LoadingOverlay from 'vue-loading-overlay';
export default {
  name: 'ManualImport',
  props: {
    accordion: {
      type: String,
      default: 'panel',
    },
  },
  components: {
    CollapsibleWidget,
    LoadingOverlay,
    MapColumnsModal,
  },
  data() {
    return {
      isLoading: true,
      file: null,
      geometryType: '',
      description: '',
      clearLayer: false,
      clearLayerCheckboxModal: false,
      formErrors: { fileError: false },
      savedCsv: [],
      fileToPublish: null,
      fileId: null,
      exitConfirmationModal: false,
      newFileModal: false,
      newFileTrigger: null,
      bulkDataInfoModal: false,
      harmonogramModal: false,
      infoModal: false,
      statementSubmited: false,
      statementsMade: true,
      nextAvailableImportDay: null,
      importAvailable: false,
      isFeaturesValid: true,
      inventarizations: [],
      selectedInventarizationId: null,
      inventarizationExportId: null,
      inventarizationFilterDataFrom: null,
      inventarizationFilterDataTo: null,
      exportStatusTimeoutId: null,
      inventarizationExportData: null,
      inventarizationExportStatus: {
        makingExport: false,
        checkingExportStatus: false,
        downloadingFile: false,
      },
      selectedPodstawaPrawna: null,
      showPodstawyPrawneFor: [],
      zasilenieManualneResponse: null,
      showMapColumnsModal: false,
      expectedColumns: [],
      responseBodyFields: [],
    };
  },
  mounted() {
    this.getOrganizationInventarizations();
  },
  computed: {
    ...mapGetters([
      'layers',
      'activeLayer',
      'activeLayerFeatures',
      'features',
      'manualImportSettings',
      'featuresColumns',
      'featuresValidationResults',
      'layersGeometryColumns',
      'tableMeta',
    ]),
    isInventarizationExportInAction() {
      return (
        this.inventarizationExportStatus.makingExport ||
        this.inventarizationExportStatus.checkingExportStatus ||
        this.inventarizationExportStatus.downloadingFile
      );
    },
    groupedLayers() {
      return this.features.reduce((acc, feature) => {
        const { layer } = feature;
        if (!acc[layer]) acc[layer] = [];
        acc[layer].push(feature);

        return acc;
      }, {});
    },
  },
  methods: {
    newManualImportDataInit(trigger) {
      this.newFileTrigger = trigger;
      this.createNewImportFileInit();
    },
    createNewImportFileInit() {
      if (this.features.length > 0) {
        this.showNewFileModal();
      } else {
        this.newManualImportData();
      }
    },
    newManualImportData() {
      switch (this.newFileTrigger) {
        case 'uploadFormFile':
          this.uploadFormFile();
          break;
        case 'uploadDataFromInventarization':
          this.uploadDataFromInventarization();
          break;
        default:
          break;
      }
    },
    resetFeatures() {
      this.$store.commit(FEATURES_SET, []);
    },
    uploadFormFile() {
      this.postCsvToJson();
    },
    validateFile() {
      const isFileValid =
        this.file && this.file.name.toLowerCase().endsWith('.csv');
      this.formErrors.fileError = !isFileValid;
      return isFileValid;
    },
    async validateSubmitManualImport() {
      await this.chechIfFeaturesAreValid();
      await this.getImportAvailability();
      await this.getStatements();
      if (
        this.importAvailable &&
        !this.statementsMade &&
        this.isFeaturesValid
      ) {
        return true;
      } else {
        return false;
      }
    },
    async chechIfFeaturesAreValid() {
      this.validateFeatures();

      this.isFeaturesValid = true;

      for (const key in this.featuresValidationResults) {
        const featureValidationResults = this.featuresValidationResults[key];
        for (const featureKey in featureValidationResults) {
          const featureValidationResult = featureValidationResults[featureKey];
          if (
            featureValidationResult.isValid === false &&
            featureValidationResult.type === 'Error'
          ) {
            this.isFeaturesValid = false;
            break; // No need to continue once we find an invalid result
          }
        }
        if (this.isFeaturesValid === false) {
          break;
        }
      }
      if (this.isFeaturesValid === false) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message:
            'Nie można wykonać publikacji. Proszę sprawdzić poprawność danych.',
          type: 'error',
          title: 'Uwaga.',
        });
      }
    },
    resetUploadFileErrors() {
      this.formErrors.fileError = false;
    },
    getLayerTitleById(layerId) {
      const layerMeta = this.layers.find((layer) => layer.id === layerId);
      if (layerMeta) {
        return layerMeta.title;
      }

      return '';
    },
    getLayerIdByFeatures(features) {
      return (
        (features && features[0] && features[0].layer) || this.activeLayer.id
      );
    },
    getFeaturesColumns(features) {
      return this.featuresColumns[this.getLayerIdByFeatures(features)];
    },
    async addFeaturesFromResponse(responseFeatures) {
      const features = this.adjustFeaturesFromFile(responseFeatures);
      const transformedFeatures = await this.transformCoordinateProjection(
        features,
        'EPSG:4326',
        'EPSG:2180'
      );
      this.addFeatures(transformedFeatures);
    },
    async modifyResponseColumns(mappedColumns) {
      const modifiedFeatures = this.responseBodyFeatures.map((feature) => {
        const modifiedFeature = Object.entries(mappedColumns).reduce(
          (acc, [key, value]) => {
            if (value) {
              return { ...acc, [key]: feature[value.key] };
            }
            return acc;
          },
          {}
        );

        return modifiedFeature;
      });

      if (this.validFeatures(modifiedFeatures)) {
        await this.addFeaturesFromResponse(modifiedFeatures);
      } else {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'error',
          title: 'Uwaga.',
          message:
            'Załadowane dane nie pasują do wybranej warstwy. Proszę wybrać inną warstwę lub utworzyć nowy plik.',
        });
        this.$store.commit(FEATURES_SET, []);
      }
    },
    async postCsvToJson() {
      this.isLoading = true;
      if (this.validateFile()) {
        this.resetUploadFileErrors();
        try {
          const api = new ApiKonwersja();
          this.file = await this.processFile(this.file);
          const response = await api.postCsvToJson({
            file: this.file,
          });

          if (response) {
            const { features } = response.body;
            this.responseBodyFeatures = features;
            if (this.validFeatures(features)) {
              await this.addFeaturesFromResponse(features);
            } else {
              this.expectedColumns = this.getFeaturesColumns(features);
              this.responseBodyFields = response.body.pola;
              this.showMapColumnsModal = true;
            }
          }
        } catch (error) {
          console.error(error);
          this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
            message: error,
            type: 'error',
            title: 'Uwaga.',
          });
        }
      }
      this.isLoading = false;
    },
    async postJsonToCsv(file, config) {
      try {
        const api = new ApiKonwersja();
        const response = await api.postJsonToCsv(
          {
            file: file,
          },
          {
            download: config.saveToFile ? true : false,
          }
        );
        if (response) {
          if (config.saveToFile) {
            this.savedCsv = [];
          } else {
            this.savedCsv = response.response;
          }
          return this.savedCsv;
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error,
          type: 'error',
          title: 'Uwaga.',
        });
      }
    },

    async postFilesUpload(layerId, file) {
      this.isLoading = true;
      const api = new ApiSysPrzePli();

      try {
        let result = await api.postFilesUpload(
          {
            wso2_id: this.contextEmail,
            orgid: this.contextOrganizationId,
            files: file,
          },
          { multipleFiles: true }
        );
        if (result) {
          this.fileId = result.body.id;
          this.createZasilenie(layerId, this.fileId);
        } else {
          this.fileId = null;
          this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
            message: 'Wystąpił nieoczekiwany błąd',
            type: 'error',
            title: 'Uwaga.',
          });
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: 'Wgranie pliku nie powiodło się. ' + error.response || error,
          type: 'error',
          title: 'Uwaga.',
        });
      }
      this.isLoading = false;
    },
    saveEditedLayersToFile() {
      Object.entries(this.groupedLayers).forEach(([layerId, group]) => {
        this.saveManualImport(
          { saveToFile: true, title: this.getLayerTitleById(layerId) },
          group
        );
      });
    },
    async saveManualImport(config, features) {
      const transformedFeatures = await this.transformCoordinateProjection(
        features,
        'EPSG:2180',
        'EPSG:4326'
      );
      const featuresObject = {
        columns: this.getFeaturesColumns(features),
        features:
          this.transformFeaturesArrayValuesToString(transformedFeatures),
      };
      const featuresJsonFile = this.makeJsonFile(featuresObject, config.title);

      return this.postJsonToCsv(featuresJsonFile, config);
    },
    makeJsonFile(data, title) {
      const jsonData = JSON.stringify(data);

      const dataBlob = new Blob([jsonData], { type: 'application/json' });

      const filename = `${title} ${moment().format('DD-MM-yyyy HH-mm')}.json`;
      const jsonFile = new File([dataBlob], filename, { type: dataBlob.type });

      return jsonFile;
    },
    makeCsvFile(data, title) {
      const dataBlob = new Blob([data], {
        type: 'text/csv;charset=utf-8;',
      });
      const filename = `${title} ${moment().format('DD-MM-yyyy HH-mm')}.csv`;
      const file = new File([dataBlob], filename, { type: filename });
      return file;
    },
    downloadCsvFile(data) {
      const dataBlob = new Blob([data], {
        type: 'text/csv;charset=utf-8;',
      });

      const blobUrl = URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${this.activeLayer.title} ${moment().format(
        'DD-MM-yyyy HH-mm'
      )}.csv`;
      document.body.appendChild(link);
      link.click();
    },
    async submitManualImport() {
      const uploadFile = async (layerId, features, title) => {
        const savedCsv = await this.saveManualImport(
          { saveToFile: false, title },
          features
        );
        if (savedCsv) {
          const savedCsvFile = this.makeCsvFile(savedCsv, title);
          await this.postFilesUpload(layerId, savedCsvFile);
        } else {
          this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
            message: 'Nie można wykonać importu, załadowany plik jest pusty',
            type: 'error',
            title: 'Uwaga.',
          });
        }
      };

      const orderedLayers = Object.entries(this.groupedLayers).sort(
        ([idA], [idB]) => {
          const metaA = this.tableMeta.find((item) => item.id === idA);
          const metaB = this.tableMeta.find((item) => item.id === idB);

          // priorytet_importu 0 should be moved at the end of array
          const priorityA = metaA.priorytet_importu || Infinity;
          const priorityB = metaB.priorytet_importu || Infinity;

          return priorityA - priorityB;
        }
      );

      if (await this.validateSubmitManualImport()) {
        orderedLayers.forEach(([layerId, group], index) => {
          setTimeout(() => {
            uploadFile(layerId, group, this.getLayerTitleById(layerId));
          }, index);
        });
      }
    },
    async createZasilenie(layerId, id) {
      this.isLoading = true;
      const api = new ApiZasilenia();
      try {
        var response = await api.postZasilenieManualne(
          {
            wso2_id: this.contextEmail,
            orgid: this.contextOrganizationId,
            id_plik: id,
            format: 'csv',
            kodowanie: 'utf-8',
            id_inwentaryzacja: this.identyfikator_inwentaryzacji,
            id_warstwa: layerId,
          },
          { jsonData: true }
        );
        if (response) {
          this.getZasilenieManualneById(response.body.id);
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: 'Wgranie pliku nie powiodło się. ' + error.response || error,
          type: 'error',
          title: 'Uwaga.',
        });
      }
      this.isLoading = false;
    },
    async getZasilenieManualneById(id) {
      this.isLoading = true;
      const api = new ApiZasilenia();
      try {
        const response = await api.getZasilenieManualneById({
          id: id,
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId,
        });
        if (response) {
          const layerId = response.body.zasilenie_masowe.warstwa_id;
          const options = this.getLegalBasisOptions(layerId);

          this.zasilenieManualneResponse = response;
          if (options.length === 1) {
            this.selectedPodstawaPrawna = options[0];
            this.confirmPodstawyPrawne(layerId);
          } else {
            const layerId = response.body.zasilenie_masowe.warstwa_id;
            this.showPodstawyPrawneFor.push({
              id: layerId,
              options,
              title: this.getLayerTitleById(layer),
            });
          }
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message:
            'Przetwarzanie zasilenia nie powiodło się. ' + error.response ||
            error ||
            '',
          type: 'error',
          title: 'Uwaga.',
        });
      }
      this.isLoading = false;
    },
    async putZasilenieMasoweParametryzacja(layerId) {
      const extraColumns = ['delete', 'selected', 'id', 'visible'];
      const columns = [
        ...(this.layersGeometryColumns[layerId].column || []),
        ...extraColumns,
      ];

      const getFilteredAttributes = (mapowanieAtrybutow) => {
        return mapowanieAtrybutow.filter(
          (atrybut) => !columns.includes(atrybut.key)
        );
      };

      const createAttributesMapping = (attributes) => {
        return attributes.reduce((obj, item) => {
          obj[item.key] = item.key;
          return obj;
        }, {});
      };
      const createDefaultValues = (attributes) => {
        return attributes.reduce((obj, item) => {
          obj[item.key] = null;
          return obj;
        }, {});
      };
      const prepareGeometry = () => {
        const geometry = this.getGeometry(layerId);
        if (geometry === 'WKT') {
          return { typ: geometry, wkt: columns[0] };
        }
        if (geometry === 'XY') {
          return { typ: geometry, x: columns[0], y: columns[1] };
        }
        return null;
      };
      const handleApiError = (error) => {
        const errorMessage =
          'Przetwarzanie zasilenia nie powiodło się. ' +
          (error.response || error || '');
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: errorMessage,
          type: 'error',
          title: 'Uwaga.',
        });
      };

      // Extract response data
      const response = this.zasilenieManualneResponse;
      const id = response.body.zasilenie_masowe.id;
      const mapowanieAtrybutowNoGeometry = getFilteredAttributes(
        response.body.zasilenie_masowe.mapowanie_atrybutow
      );

      // Fixed coordinate system for now
      const choosenCoordinateSystem = '4326';

      // Prepare attributes mapping and default values
      const attributesMapping = createAttributesMapping(
        mapowanieAtrybutowNoGeometry
      );
      const defaultValues = createDefaultValues(mapowanieAtrybutowNoGeometry);

      // Geometry handling
      const geometry = prepareGeometry();

      // Parameters for API call
      const requestBody = {
        automatyczna_publikacja: true,
        czyszczenie: this.clearLayer,
        status: 'parametryzacja',
        uklad: choosenCoordinateSystem,
        mapowanie_atrybutow: attributesMapping,
        default_values: defaultValues,
        zmiana_poligonu_na_centroid: false,
        opis: this.description,
        geometria: geometry,
        legal_basis: this.selectedPodstawaPrawna,
      };

      // Call the API
      this.isLoading = true;
      const api = new ApiZasilenia();
      try {
        const response = await api.putZasilenieManualneById(
          {
            id,
            wso2_id: this.contextEmail,
            orgid: this.contextOrganizationId,
            body: requestBody,
          },
          { jsonData: true }
        );
        if (response) {
          this.startImport(response.body.id);
        }
      } catch (error) {
        handleApiError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async startImport(id) {
      this.isLoading = true;
      const api = new ApiZasilenia();
      try {
        const response = await api.startImportById({
          id: id,
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId,
        });
        if (response && this.showPodstawyPrawneFor.length <= 1) {
          this.showBulkDataInfoModal();
          this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
            type: 'success',
            title: 'Sukces',
            message: 'Manualne zasilenie zakończone powodzeniem',
          });
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message:
            'Wystąpił błąd podczas importu pliku. ' + error.response || error,
          type: 'error',
          title: 'Uwaga.',
        });
      }
      this.isLoading = false;
    },
    getLegalBasisOptions(layerId) {
      const layerMeta = this.tableMeta.find((table) => table.id === layerId);

      const optionsSet = new Set(
        layerMeta.terminy_inwentaryzacji.map(
          ({ podstawa_prawna }) => podstawa_prawna
        )
      );

      return Array.from(optionsSet);
    },
    cancel() {
      this.showExitModal();
    },
    showExitModal() {
      this.exitConfirmationModal = true;
    },
    hideExitModal() {
      this.exitConfirmationModal = false;
    },
    showNewFileModal() {
      this.newFileModal = true;
    },
    hideNewFileModal() {
      this.newFileModal = false;
    },
    showBulkDataInfoModal() {
      this.bulkDataInfoModal = true;
    },
    hideBulkDataInfoModal() {
      this.bulkDataInfoModal = false;
    },
    showHarmonogramModal() {
      this.harmonogramModal = true;
    },
    hideHarmonogramModal() {
      this.harmonogramModal = false;
    },
    showInfoModal() {
      this.infoModal = true;
    },
    hideInfoModal() {
      this.infoModal = false;
    },
    redirectToDataFeedRecord() {
      location.href = `${window.location.origin}/admin/#/datafeedrecord/page`;
    },
    exitEditMode() {
      this.$store.dispatch(EDIT_SESSION_END);
    },
    validFeatures(features) {
      let featureIsMissing = false;

      const featuresColumns = this.getFeaturesColumns(features);
      features.forEach((feature) => {
        for (let prop in feature) {
          const found = featuresColumns.find((featuresColumn) => {
            return featuresColumn.key.toLowerCase() == prop.toLowerCase();
          });
          if (!found) {
            featureIsMissing = true;
            break;
          }
        }
      });

      return !featureIsMissing;
    },
    adjustFeaturesFromFile(features) {
      return this.changeFeaturesStringFieldsToArray(features);
    },
    async getImportAvailability() {
      try {
        const api = new ApiHarmonogramZasilen();
        const response = await api.getZasileniaDostepne({
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId,
        });

        if (response) {
          this.importAvailable = response.body.dostepne;
          if (!response.body.dostepne) {
            this.showHarmonogramModal();
          }
          this.nextAvailableImportDay = response.body.nastepny;
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message:
            'Wystąpił błąd podczas importu pliku. ' + error.response || error,
          type: 'error',
          title: 'Uwaga.',
        });
      }
    },
    async getStatements() {
      try {
        const api = new ApiZasilenia();

        const response = await api.getStatements({
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId,
          inventoryName: this.identyfikator_inwentaryzacji,
        });

        if (response) {
          this.statementsMade =
            response.body.infrastruktura.zaznaczony ||
            response.body.uslugi_kolokacja.zaznaczony ||
            response.body.nieposiadanie.zaznaczony;
          this.statementSubmited = response.body.nieposiadanie.zaznaczony;
          if (this.statementsMade) {
            this.showInfoModal;
          }
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message:
            'Wystąpił błąd podczas importu pliku. ' + error.response || error,
          type: 'error',
          title: 'Uwaga.',
        });
      }
    },
    getGeometry(layerId) {
      const columns = this.layersGeometryColumns[layerId].column;
      if (!columns) {
        return null;
      } else if (columns.length == 1) {
        return 'WKT';
      } else if (columns.length == 2) {
        return 'XY';
      }
    },
    transformFeaturesArrayValuesToString(features) {
      const arrayColumns = this.getFeaturesColumns(features).filter(
        (column) => column.dictionary == 2
      );

      const updatedFeatures = features.map((feature) => {
        const updatedFeature = { ...feature };

        arrayColumns.forEach((column) => {
          if (updatedFeature.hasOwnProperty(column.key)) {
            updatedFeature[column.key] = Array.isArray(
              updatedFeature[column.key]
            )
              ? `${updatedFeature[column.key].join(';')}`
              : updatedFeature[column.key].toString();
          }
        });

        return updatedFeature;
      });

      return updatedFeatures;
    },
    transformStringToFeaturesArrayValues() {
      const arrayColumns = this.getFeaturesColumns().filter(
        (column) => column.dictionary == 2
      );

      const updatedFeatures = this.features.map((feature) => {
        const updatedFeature = { ...feature };

        arrayColumns.forEach((column) => {
          if (updatedFeature.hasOwnProperty(column.key)) {
            updatedFeature[column.key] = Array.isArray(
              updatedFeature[column.key]
            )
              ? `${updatedFeature[column.key].join(';')}`
              : updatedFeature[column.key].toString();
          }
        });

        return updatedFeature;
      });

      return updatedFeatures;
    },
    async processFile(file) {
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onload = (event) => {
          const fileContents = event.target.result;
          const modifiedContents = this.processLines(fileContents);
          const modifiedFile = new File(
            [modifiedContents],
            `modified_${file.name}`,
            { type: file.type }
          );
          resolve(modifiedFile);
        };
        reader.onerror = reject;
        reader.readAsText(file);
      });
    },
    processLines(fileContents) {
      const lines = fileContents.split('\n');
      for (let i = 1; i < lines.length; i++) {
        const line = lines[i];
        if (line.startsWith('"') && line.endsWith('"')) {
          lines[i] = line.slice(1, -1);
        }
      }
      return lines.join('\n');
    },
    async validateFeatures() {
      await this.$store.dispatch(EDIT_SESSION_VALIDATE_FEATURES);
    },
    async uploadDataFromInventarization() {
      this.inventarizationExportData = null;
      if (this.selectedInventarizationId) {
        await this.postInventarizationExportRequest();
        await this.getInventarizationExportStatus();
      } else {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'warn',
          title: 'Uwaga. Nie wybrano inwentaryzacji',
          message: 'W celu załadowania danych należy wybrać inwentaryzację.',
          duration: 10000,
          changedDuration: 10000,
        });
      }
    },
    async postInventarizationExportRequest() {
      this.inventarizationExportStatus.makingExport = true;
      this.inventarizationFilterDataFrom = moment()
        .subtract(2, 'hour')
        .toISOString()
        .slice(0, -1);
      let body = {
        bbox: null,
        format: 'csv',
        ids: null,
        uklad: this.$store.getters.coordinateSystem,
        inventory_id: this.selectedInventarizationId,
      };
      try {
        const api = new ApiWarstwy();
        this.isLoading = true;

        const response = await api.postWarstwyWektoroweByIdEksport(
          {
            body: body,
            wso2_id: this.contextEmail,
            orgid: this.contextOrganizationId,
            id: this.activeLayer.id,
          },
          { jsonData: true }
        );

        if (response) {
          this.inventarizationExportId = response.body.id;
          this.inventarizationFilterDataTo = moment()
            .add(2, 'hour')
            .toISOString()
            .slice(0, -1);
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message:
            'Wystąpił błąd podczas inicjowania eksportu. ' + error.response ||
            error,
          type: 'error',
          title: 'Uwaga.',
        });
      } finally {
        this.isLoading = false;
        this.inventarizationExportStatus.makingExport = false;
        this.inventarizationExportStatus.checkingExportStatus = true;
      }
    },
    async getInventarizationExportStatus() {
      try {
        const api = new ApiWarstwy();
        this.isLoading = true;

        const response = await api.getWarstwyWektoroweEksport({
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId,
          page_number: 1,
          items_per_page: 10000,
          data_od: this.inventarizationFilterDataFrom,
        });

        if (response) {
          const foundExport = response.body.eksporty.find((el) => {
            return el.id === this.inventarizationExportId;
          });
          if (this.exportStatusTimeoutId) {
            clearTimeout(this.exportStatusTimeoutId);
          }
          if (!foundExport || foundExport.status !== 'wyeksportowany') {
            this.exportStatusTimeoutId = setTimeout(() => {
              this.getInventarizationExportStatus();
            }, 5000);
          } else {
            this.inventarizationExportStatus.checkingExportStatus = false;

            this.getWarstwyWektoroweResultDownload(
              this.inventarizationExportId
            );
          }
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message:
            'Wystąpił błąd podczas pobierania statusu eksportu. ' +
              error.response || error,
          type: 'error',
          title: 'Uwaga.',
        });
      } finally {
        this.isLoading = false;
      }
    },
    async getWarstwyWektoroweResultDownload(id) {
      this.inventarizationExportStatus.downloadingFile = true;
      try {
        const api = new ApiWarstwy();
        const response = await api.getWarstwyWektoroweResultDownload(
          {
            wso2_id: this.contextEmail,
            orgid: this.contextOrganizationId,
            id: id,
          },
          { ignoreGlobalErrors: true }
        );
        if (response) {
          this.inventarizationExportStatus.downloadingFile = false;
          this.inventarizationExportData = response.response;
          this.addFeaturesFromInventarization(
            this.adjustDataFromInventarization(this.inventarizationExportData)
          );
        }
      } catch (error) {
        this.showErrorModal = true;
        if (error.response instanceof Blob) {
          error.response.text().then((error) => {
            this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
              message:
                'Wystąpił nieoczekiwany błąd. ' + error.response || error,
              type: 'error',
              title: 'Uwaga.',
            });
          });
        } else {
          this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
            message: 'Wystąpił nieoczekiwany błąd. ' + error.response || error,
            type: 'error',
            title: 'Uwaga.',
          });
        }
      }
    },
    adjustDataFromInventarization(data) {
      let transformedStringDataToArrays =
        this.transformStringDataToArrays(data);
      let inventarizationDataColumns = [];

      if (transformedStringDataToArrays.length > 1) {
        //.pop() removes last feature from array if it's empty
        if (
          transformedStringDataToArrays[
            transformedStringDataToArrays.length - 1
          ].length < transformedStringDataToArrays[0].length
        ) {
          transformedStringDataToArrays.pop();
        }
        //separate attributes columns to new array and remove it from dataArray
        inventarizationDataColumns = transformedStringDataToArrays[0];
        transformedStringDataToArrays.shift();
      }
      let features = this.transformFeaturesArraysToObjects(
        transformedStringDataToArrays,
        inventarizationDataColumns
      );
      features = this.transformWktGeometryToXY(
        features,
        inventarizationDataColumns
      );
      return this.changeFeaturesStringFieldsToArray(features);
    },
    transformStringDataToArrays(data) {
      // Remove double quotes
      data = data.replace(/"/g, '');

      // Replace commas inside parentheses with a unique character or string
      const dataWithReplacedCommas = data.replace(/\(([^)]+)\)/g, (match) => {
        return match.replace(/,/g, '|'); // Replace commas inside parentheses with '|'
      });

      // Split the modified string by newline character
      const dataArray = dataWithReplacedCommas.split('\n');

      // Map each line and split by ',' (comma)
      const result = dataArray.map((line) => {
        const parts = line.split(',');

        // Restore commas inside parentheses in each part
        const restoredParts = parts.map((part) => part.replace(/\|/g, ','));

        return restoredParts;
      });

      return result;
    },
    transformFeaturesArraysToObjects(features, columns) {
      return features.map((feature) => {
        const obj = {};
        feature.forEach((attribute, index) => {
          const columnName = columns[index];

          obj[columnName] = attribute;
        });
        return obj;
      });
    },
    transformWktGeometryToXY(features, columns) {
      const layerId = this.getLayerIdByFeatures(features);
      const layerColumns = this.layersGeometryColumns[layerId].column;
      if (layerColumns && layerColumns.length === 2) {
        //changing geometry wkt to xy for specific layers
        const extraGeometryColumn = columns.find((el) => {
          return el.includes('00_lokalizacja');
        });
        return (features = features.map((feature) => {
          if (feature[extraGeometryColumn]) {
            const regex = /(\d+\.\d+)\s(\d+\.\d+)/;
            const matches = feature[extraGeometryColumn].match(regex);
            feature[layerColumns[0]] = matches[1];
            feature[layerColumns[1]] = matches[2];
            delete feature[extraGeometryColumn];
          }
          return feature;
        }));
      }
      return features;
    },
    changeFeaturesStringFieldsToArray(features) {
      features.forEach((feature) => {
        this.getFeaturesColumns(features).forEach((featuresColumn) => {
          if (!feature.hasOwnProperty(featuresColumn.key)) {
            if (featuresColumn.dictionary == 2) {
              feature[featuresColumn.key] = [];
            } else {
              feature[featuresColumn.key] = '';
            }
          } else {
            if (featuresColumn.dictionary == 2) {
              if (feature[featuresColumn.key] == '') {
                feature[featuresColumn.key] = [];
              } else {
                feature[featuresColumn.key] =
                  feature[featuresColumn.key].split(';');
              }
            }
          }
        });
      });
      return features;
    },
    async addFeaturesFromInventarization(features) {
      if (features && features.length > 0) {
        const transformedFeatures = await this.transformCoordinateProjection(
          features,
          'EPSG:4326',
          'EPSG:2180'
        );
        this.addFeatures(transformedFeatures);
      } else {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'warn',
          title: 'Uwaga. Brak danych z inwentaryzacji',
          message: `Dla aktywnej warstwy nie znaleziono danych do załadowania z inwentaryzacji ${this.selectedInventarizationId}.`,
          duration: 10000,
          changedDuration: 10000,
        });
      }
    },
    async getOrganizationInventarizations() {
      try {
        this.isLoading = true;
        const api = new ApiZasilenia();
        const response = await api.getOrganizationinventarizations({
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId,
        });

        if (response) {
          this.inventarizations = response.body.inwentaryzacje.map((el) => {
            return el.inwentaryzacja;
          });
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message:
            'Wystąpił błąd podczas pobierania listy inwentaryzacji. ' +
              error.response || error,
          type: 'error',
          title: 'Uwaga.',
        });
      } finally {
        this.isLoading = false;
      }
    },
    async transformCoordinateProjection(
      features,
      sourceProjection,
      targetProjection
    ) {
      const layerId = this.getLayerIdByFeatures(features);

      if (!this.layersGeometryColumns[layerId].column) {
        return features;
      }

      const transformGeometry = (geometry, type) => {
        switch (type) {
          case 'point':
            return transform(geometry, sourceProjection, targetProjection);
          case 'linestring':
            return geometry.map((singleGeometry) =>
              transform(singleGeometry, sourceProjection, targetProjection)
            );
          case 'polygon':
            return [
              geometry[0].map((singleGeometry) =>
                transform(singleGeometry, sourceProjection, targetProjection)
              ),
            ];
          default:
            return geometry;
        }
      };

      const transformedFeatures = await Promise.all(
        features.map(async (feature) => {
          const geometry = await this.$store.dispatch(
            EDIT_SESSION_GET_FEATURE_GEOMETRY,
            feature
          );

          if (!geometry) return feature;

          const transformedGeometry = transformGeometry(
            geometry,
            this.activeLayer.type
          );

          return {
            ...feature,
            ...(await this.$store.dispatch(
              EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY,
              transformedGeometry
            )),
          };
        })
      );

      return transformedFeatures;
    },
    addFeatures(features) {
      features.forEach((feature) => {
        this.$store.dispatch(EDIT_SESSION_ADD_FEATURE, feature);
      });
      this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'success',
        title: 'Sukces',
        message: `Poprawnie załadowano ${this.features.length || 0} ${
          this.features && this.features.length === 1 ? 'rekord' : 'rekordów'
        }.`,
      });
    },

    clickClearLayerCheckbox(event) {
      event.preventDefault();
      if (this.clearLayer) {
        this.clearLayer = false;
      } else {
        this.clearLayerCheckboxModal = true;
      }
    },
    confirmChange() {
      this.clearLayer = true;
      this.clearLayerCheckboxModal = false;
    },
    cancelChange() {
      this.clearLayerCheckboxModal = false;
    },
    async confirmPodstawyPrawne(layerId) {
      await this.putZasilenieMasoweParametryzacja(layerId);
      this.showPodstawyPrawneFor.splice(0, 1);
      this.selectedPodstawaPrawna = null;
    },
  },
};
</script>

<style scoped>
.file-input {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
